import { render, staticRenderFns } from "./monoDirectDebit.vue?vue&type=template&id=280a1486&scoped=true"
import script from "./monoDirectDebit.vue?vue&type=script&lang=js"
export * from "./monoDirectDebit.vue?vue&type=script&lang=js"
import style0 from "./monoDirectDebit.vue?vue&type=style&index=0&id=280a1486&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280a1486",
  null
  
)

export default component.exports